import { createTimeline } from "animejs";
import { TbArrowRight } from "solid-icons/tb";
import { onMount } from "solid-js";

export const HeroHeading = () => {
  let r1!: HTMLSpanElement;
  let r2!: HTMLSpanElement;
  let r3!: HTMLSpanElement;
  let r4!: HTMLSpanElement;
  let r5!: HTMLSpanElement;
  let r6!: HTMLSpanElement;
  let r7!: HTMLSpanElement;
  let r8!: HTMLSpanElement;
  let r9!: HTMLSpanElement;
  let r10!: HTMLSpanElement;
  let r11!: HTMLSpanElement;

  onMount(() => {
    const clear = (obj: HTMLElement) => {
      Object.assign(obj.style, {
        transform: "",
      });
    };
    const show = (obj: HTMLElement) => {
      obj.classList.remove("hidden");
    };
    const hide = (obj: HTMLElement) => {
      obj.classList.add("hidden");
    };

    const tl = createTimeline({
      loop: 1,
      loopDelay: 4000,
      defaults: {
        duration: 250,
      },
      onLoop() {
        show(r1);
        show(r2);
        [r1, r2, r3, r4, r5, r6, r7, r8, r9, r10, r11].forEach(clear);
        [r3, r4, r5, r6, r7, r8, r9, r10, r11].forEach(hide);
      },
    });

    const sequence = (arrow: HTMLElement, interim: HTMLElement, final: HTMLElement) => {
      tl.add(
        [arrow, interim, final],
        {
          opacity: [0, 1],
          translateX: [30, 0],
          onBegin: () => {
            show(arrow);
            show(interim);
            show(final);
          },
          duration: 250,
        },
        "+=500",
      )
        .add(
          interim,
          {
            opacity: 0,
            translateX: -interim.clientWidth,
            onComplete() {
              hide(interim);
              clear(interim);
            },
          },
          "+=1000",
        )
        .add(
          final,
          {
            translateX: -interim.clientWidth,
            onComplete() {
              clear(final);
            },
          },
          "<<",
        );
    };

    tl.add(
      r1,
      {
        translateX: -r1.clientWidth,
        opacity: 0,
        onComplete() {
          hide(r1);
          clear(r1);
        },
      },
      2000,
    );
    tl.add(
      r2,
      {
        translateX: -r1.clientWidth,
        onComplete() {
          clear(r2);
        },
      },
      "<<",
    );

    sequence(r3, r4, r5);
    sequence(r6, r7, r8);
    sequence(r9, r10, r11);

    tl.play();
  });
  return (
    <div>
      <h2 class="relative mt-20 mb-0 text-xl md:text-3xl font-medium flex items-center max-w-4xl mx-auto flex-wrap gap-2">
        <span ref={r1}>Transform your messy, unstructured</span>
        <span
          ref={r2}
          class="font-semibold text-brand dark:text-blue-300 dark:text-shadow-glow dark:text-shadow-blue-600"
        >
          Data
        </span>
        <span ref={r3} class="hidden">
          <TbArrowRight class="inline-block size-5 stroke-3 text-muted-text" />
        </span>
        <span ref={r4} class="hidden">
          Into key{" "}
        </span>
        <span
          ref={r5}
          class="hidden font-semibold text-brand dark:text-blue-300 dark:text-shadow-glow dark:text-shadow-blue-600"
        >
          Insights
        </span>
        <span ref={r6} class="hidden">
          <TbArrowRight class="inline-block size-5 stroke-3 text-muted-text" />
        </span>
        <span ref={r7} class="hidden">
          to craft an optimal{" "}
        </span>
        <span
          ref={r8}
          class="hidden font-semibold text-brand dark:text-blue-300 dark:text-shadow-glow dark:text-shadow-blue-600"
        >
          Strategy
        </span>
        <span ref={r9} class="hidden">
          <TbArrowRight class="inline-block size-5 stroke-3 text-muted-text" />
        </span>
        <span ref={r10} class="hidden">
          that drives actionable{" "}
        </span>
        <span
          ref={r11}
          class="hidden font-semibold text-brand dark:text-blue-300 dark:text-shadow-glow dark:text-shadow-blue-600"
        >
          Results
        </span>
      </h2>
    </div>
  );
};
